// removed by extract-text-webpack-plugin
module.exports = {"note-icon":"NoteIcon__note-icon___1EpWM","note-icon-mobile":"NoteIcon__note-icon-mobile___1Q_dJ"};